module.exports = __webpack_public_path__ + "img/shiba-body-level3.c23b35d2.png";